import React, { Component } from 'react';
import {Input, Textarea, RichTextarea, DatePicker} from 'components/danangtrade-forms/common';
import {SingleImageUploader} from 'components/uploader';
import {toastr} from 'react-redux-toastr';
import {withRouter} from 'react-router-dom'
import {Fairs} from 'api'

class EmailApprove extends Component {
  constructor(props) {
    super(props)
    this.state = {
      banner: '',
      content: '',
      vitradeSiteURL: '',
      pavoSiteURL: ''
    }
  }

  componentDidMount() {
    Fairs.actions.get.request({id: this.props.params.id}).then(res => {
      if (res.data) {
        let approveEmailInfo = res.data.fair && res.data.fair.approveEmailInfo ? res.data.fair.approveEmailInfo : {}
        this.setState({
          banner: approveEmailInfo.banner || '',
          content: approveEmailInfo.content || '',
          vitradeSiteURL: approveEmailInfo.vitradeSiteURL || '',
          pavoSiteURL: approveEmailInfo.pavoSiteURL || ''
        })
      }
    })
  }

  submit(e) {
    e.preventDefault();
    if(this.validateSubmitForm()) {
      let params = {
        approveEmailInfo: {
          banner: this.state.banner,
          content: this.state.content,
          vitradeSiteURL: this.state.vitradeSiteURL,
          pavoSiteURL: this.state.pavoSiteURL
        }
      }
      Fairs.actions.update.request({id: this.props.params.id}, params).then(res => {
        toastr.success('Thành công!', 'Lưu thông tin thành công');
        this.props.history.push(`/fair/${this.props.params.id}`);
      })
    }
  }

  validateSubmitForm() {
    let pass = true;
    this.props.validators['formEmail'].map(validator => {
      if (pass)
        pass = validator.validate();
      else
        validator.validate();
    });

    if (!this.state.banner || !this.state.banner.trim()) {
      pass = false;
      toastr.error('Lỗi!', 'Banner email là bắt buộc');
    }

    return pass;
  }

  onChange(name, e) {
    this.setState({
      [name]: e.target.value
    })
  }

  onRemoveImage(name) {
    this.setState({
      [name]: ''
    });
  }

  onUploadComplete(name, image) {
    this.setState({
      [name]: image.name
    });
  }

  render() {
    return (
      <form className='form-email' onSubmit={this.submit.bind(this)}>
        <SingleImageUploader
          fnUpload={Fairs.actions.upload.request}
          onUploadComplete={this.onUploadComplete.bind(this, 'banner')}
          onRemoveImage={this.onRemoveImage.bind(this, 'banner')}
          title='Banner email'
          image={this.state.banner}
          type='FAIR'
        />
        <Input type="text" placeholder="Link website vitrade"
          className='has-feedback fg-custom'
          value={this.state.vitradeSiteURL}
          required
          onChange={this.onChange.bind(this, 'vitradeSiteURL')}
          bindValidator={this} channel="formEmail"
          errorMessage="Nội dung này không được để trống"
        />
        <Input type="text" placeholder="Link website hội chợ"
          className='has-feedback fg-custom'
          value={this.state.pavoSiteURL}
          required
          onChange={this.onChange.bind(this, 'pavoSiteURL')}
          bindValidator={this} channel="formEmail"
          errorMessage="Nội dung này không được để trống"
        />
        <Textarea type="text" placeholder="Nội dung email"
          className='fg-custom vitrade-textarea'
          iconFontSet='glyphicon'
          iconClassName='glyphicon-user'
          value={this.state.content}
          onChange={this.onChange.bind(this, 'content')}
          required
          bindValidator={this} channel="formEmail"
          errorMessage="Nội dung này không được để trống"
        />
        <div className='wrap-btn-actions'>
          <button type='submit' className='btn btn-action'>Lưu thông tin</button>
        </div>
      </form>
    );
  }
}


EmailApprove.defaultProps = {
  validators: {
    formEmail: []
  }
};

export default withRouter(EmailApprove)


// WEBPACK FOOTER //
// ./components/fair/fair-email/EmailApprove.jsx